module.exports={
	"ViewIdentifier": "Empty",
	"DefaultRenderable": "EmptyWrap",
	"DefaultDestinationAddress": "#PlatformConfiguration-MainViewport-Sink",
	"AutoRender": false,
	"Templates": [
		{
			"Hash": "EmptyWrap",
			"Template": ""
		}
	],
	"Renderables": [
		{
			"RenderableHash": "EmptyWrap",
			"TemplateHash": "EmptyWrap",
			"DestinationAddress": "#PlatformConfiguration-MainViewport-Sink"
		}
	]
}
